import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Drawer, Form, Input, Switch, message } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import { getDesignationListing } from "services/redux/adminSettings/organizationStructure/designation/action";
import axios from "axios";
import { appBaseUrl } from "utils/config";

const Designation = () => {
  const dispatch = useDispatch();
  const { designationListing } = useSelector((state) => state.designation);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingDesignation, setEditingDesignation] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getDesignationListing());
  }, [dispatch]);

  const openDrawer = (record = null) => {
    setEditingDesignation(record);
    setDrawerVisible(true);
    if (record) {
      form.setFieldsValue({
        designationId: record.designationId,
        designationName: record.designationName,
        isActive: record.isActive,
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ isActive: true });
    }
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setEditingDesignation(null);
    form.resetFields();
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      await axios.post(
        `${appBaseUrl}/organizationStructure/designationAddUpdate`,
        values
      );
      message.success(
        editingDesignation ? "Designation updated" : "Designation added"
      );
      closeDrawer();
      dispatch(getDesignationListing());
    } catch (err) {
      message.error("Failed to save designation");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "S.NO",
      dataIndex: "sno",
      key: "sno",
      render: (text, record, index) => index + 1,
      width: 80,
    },
    {
      title: "Designation Name",
      dataIndex: "designationName",
      key: "designationName",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) => (
        <span style={{ color: isActive ? "#52c41a" : "#f5222d" }}>
          {isActive ? "ACTIVE" : "INACTIVE"}
        </span>
      ),
      width: 120,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          icon={<EditOutlined />}
          type="link"
          onClick={() => openDrawer(record)}
        >
          Edit
        </Button>
      ),
      width: 100,
    },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h2>Designation</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => openDrawer()}
        >
          Add Designation
        </Button>
      </div>
      <Table
        dataSource={designationListing || []}
        columns={columns}
        rowKey="designationId"
        pagination={{ pageSize: 10 }}
      />
      <Drawer
        title={editingDesignation ? "Edit Designation" : "Add Designation"}
        width={400}
        onClose={closeDrawer}
        visible={drawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="designationId" style={{ display: "none" }}>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item
            name="designationName"
            label="Designation Name"
            rules={[
              { required: true, message: "Please enter designation name" },
            ]}
          >
            <Input placeholder="Enter designation name" />
          </Form.Item>
          <Form.Item
            name="isActive"
            label="Status"
            valuePropName="checked"
            initialValue={true}
          >
            <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
          </Form.Item>
          <div style={{ textAlign: "right" }}>
            <Button onClick={closeDrawer} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" loading={loading} onClick={handleSubmit}>
              {editingDesignation ? "Update" : "Add"}
            </Button>
          </div>
        </Form>
      </Drawer>
    </div>
  );
};

export default Designation;
